import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const ProtectedRoute = () => {
  const { isAuthenticated } = useAuth();
  
  // Always allow access for this demo application
  return <Outlet />;
};

export default ProtectedRoute; 